const ITEMS = [
  "LINEA CREMISI",
  "IL NUOVO EP È FUORI ORA",
  "CHITARRE SPORCHE, PAROLE VERE",
  "SOTTO UN CIELO ROSSO CREMISI",
];

function Row() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-display whitespace-nowrap px-8 text-4xl tracking-wide sm:text-6xl ${
              i % 2 === 0 ? "text-neutral-100" : "text-outline-red"
            }`}
          >
            {item}
          </span>
          <span className="font-serif-logo text-2xl text-[#C8102E]">◆</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee-ribbon"
      className="relative -rotate-1 overflow-hidden border-y border-red-950/60 bg-[#0D0D0D] py-5"
    >
      <div className="marquee-track flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
